import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'horasMinutos',
  standalone: true
})
export class HorasMinutosPipe implements PipeTransform {

  transform(valorMinutos: number): string {
    if (isNaN(valorMinutos)) return '';

    const horas = Math.floor(valorMinutos / 60);
    const minutos = valorMinutos % 60;

    let resultado = '';
    if (horas > 0) {
      resultado += `${horas}h `;
    }
    resultado += `${minutos}m`;

    return resultado;
  }

}
